(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // wcVgbeData.videos enthält jetzt IDs oder komplette URLs
    var items = (window.wcVgbeData && Array.isArray(wcVgbeData.videos)) ? wcVgbeData.videos : [];
    if (!items.length) return;

    document.querySelectorAll('.woocommerce-product-gallery--with-images').forEach(function(gallery) {
      console.log('wcVgbeData.videos:', items);
      var wrapper = gallery.querySelector('.woocommerce-product-gallery__wrapper');
      var navThumbs = gallery.querySelector('.flex-control-thumbs');
      if (!wrapper) return;

      items.forEach(function(raw) {
        var src = (typeof raw === 'string') ? raw.trim() : '';
        var embedUrl = '', thumbUrl = '', match;

        // YouTube ID oder URL?
        match = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w\-_]+)/);
        if (match) {
          var id = match[1];
          embedUrl = 'https://www.youtube.com/embed/' + id;
          thumbUrl = 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
        }
        // Vimeo ID oder URL?
        else if ((match = src.match(/(?:vimeo\.com\/(\d+)|player\.vimeo\.com\/video\/(\d+))/))) {
          var id = match[1] || match[2];
          embedUrl = 'https://player.vimeo.com/video/' + id;
          thumbUrl = 'https://i.vimeocdn.com/video/' + id + '_295x166.jpg'; // einfache Thumbnail-URL
        }
        // Roh-ID (YouTube)?
        else if (/^[\w\-_=]+$/.test(src)) {
          embedUrl = 'https://www.youtube.com/embed/' + src;
          thumbUrl = 'https://img.youtube.com/vi/' + src + '/hqdefault.jpg';
        }
        if (!embedUrl) return;

        // Galerie-Slide bauen
        var slide = document.createElement('div');
        slide.className = 'woocommerce-product-gallery__image';
        slide.setAttribute('data-thumb', thumbUrl);

        var link = document.createElement('a');
        link.href = '#';
        link.className = 'wc-vgbe-thumb';
        link.dataset.embedUrl = embedUrl;

        var img = document.createElement('img');
        img.src = thumbUrl;
        img.className = 'test';
        img.draggable = false;

        var play = document.createElement('span');
        play.className = 'wc-vgbe-play-button';

        link.appendChild(img);
        link.appendChild(play);
        slide.appendChild(link);
        wrapper.appendChild(slide);

        // Navigations-Thumbnails
        // if (navThumbs) {
        //   var li = document.createElement('li');

        //   var navImg = document.createElement('img');
        //   navImg.src = thumbUrl;
        //   navImg.className = "test2";
        //   navImg.draggable = false;
          
        //   // Play-Button auf Nav-Thumbnail
        //   var navPlay = document.createElement('span');
        //   navPlay.className = 'wc-vgbe-play-button';

        //   li.appendChild(navImg);
        //   li.appendChild(navPlay);

        //   navThumbs.appendChild(li);
        // }

        // Navigations-Thumbnails
        if (navThumbs) {
          var li = document.createElement('li');
          li.style.position = 'relative';

          var navImg = document.createElement('img');
          navImg.src = thumbUrl; // FEHLER: war "thumb", muss "thumbUrl" sein
          navImg.draggable = false;
          li.appendChild(navImg);

          // Zusätzlicher Play-Button auf Nav-Thumbnail
          var navPlay = document.createElement('span');
          navPlay.className = 'wc-vgbe-play-button';
          li.appendChild(navPlay);

          navThumbs.appendChild(li);
        }

        // Lightbox-Handler
        // link.addEventListener('click', function(e) {
        //   e.preventDefault();
        //   var overlay = document.createElement('div');
        //   overlay.className = 'wc-vgbe-overlay';

        //   var iframe = document.createElement('iframe');
        //   iframe.src = this.dataset.embedUrl + '?autoplay=1';
        //   iframe.setAttribute('frameborder', '0');
        //   iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        //   iframe.allowFullscreen = true;
        //   iframe.className = 'wc-vgbe-frame';

        //   var closeBtn = document.createElement('button');
        //   closeBtn.className = 'wc-vgbe-close';
        //   closeBtn.textContent = '×';

        //   overlay.appendChild(iframe);
        //   overlay.appendChild(closeBtn);
        //   document.body.appendChild(overlay);

        //   closeBtn.addEventListener('click', function() {
        //     document.body.removeChild(overlay);
        //   });
        // });
        link.addEventListener('click', function(e){
  e.preventDefault();
  // Remove old overlay if exists
  var existing = document.querySelector('.wc-vgbe-overlay');
  if (existing) existing.remove();

          // Create overlay backdrop
          var overlay = document.createElement('div');
          overlay.className = 'wc-vgbe-overlay';
          // Close when clicking outside video
          overlay.addEventListener('click', function(evt){
            if (evt.target === overlay) {
              overlay.remove();
            }
          });

          // var iframe = document.createElement('iframe');
          // iframe.src = url.replace(/watch\?v=/, 'embed/') + '?autoplay=1';
          // iframe.frameBorder = '0';
          // iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
          // iframe.allowFullscreen = true;
          // iframe.className = 'wc-vgbe-frame';

          var iframe = document.createElement('iframe');
          iframe.src = this.dataset.embedUrl + '?autoplay=1';
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
          iframe.allowFullscreen = true;
          iframe.className = 'wc-vgbe-frame';

          var closeBtn = document.createElement('button');
          closeBtn.className = 'wc-vgbe-close';
          closeBtn.textContent = '×';
          closeBtn.addEventListener('click', function(){
            overlay.remove();
          });

          overlay.appendChild(iframe);
          overlay.appendChild(closeBtn);
          document.body.appendChild(overlay);
        });

      });
    });
  });
})();
